var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96001(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-96-001-1{fill:#fff;}.cls-96-001-2,.cls-96-001-3{fill:none;}.cls-96-001-2{stroke:#6f6e6f;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "taustavalko"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-96-001-1",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-96-001-2",
    x1: 82.1,
    y1: 57.3,
    x2: 13.9,
    y2: 57.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-001-2",
    d: "M23.86,45.33l-10,12m68.21-27-10.4,2m-37,37.28L27.06,46m23-16.47L36.8,69.57m22.33-27-6.49-13.3m9.73,13.45,4.25-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-001-2",
    d: "M29.41,42.74A3.39,3.39,0,1,1,26,39.35,3.39,3.39,0,0,1,29.41,42.74ZM51.15,22.88a3.39,3.39,0,1,0,3.39,3.39A3.39,3.39,0,0,0,51.15,22.88ZM35.74,69.38a3.39,3.39,0,1,0,3.39,3.39A3.39,3.39,0,0,0,35.74,69.38ZM60.61,42.25A3.39,3.39,0,1,0,64,45.64,3.39,3.39,0,0,0,60.61,42.25Zm7.77-12.73a3.4,3.4,0,1,0,3.39,3.4A3.4,3.4,0,0,0,68.38,29.52Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96001);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_001.2a80633046f4094bcdd03fa9fc5fa1af.svg";
export { ForwardRef as ReactComponent };